import { Component, OnInit, OnDestroy, Input} from '@angular/core';
import { Survey } from '../../core/models/survey/survey.model';
import { Booking } from '../../core/models/booking.model';
import { Real } from '../../core/models/real.model';
import { Question } from '../../core/models/survey/question.model';
import { RatingQuestion } from '../../core/models/survey/rating-question.model';
import { YesNoQuestion } from '../../core/models/survey/yes-no-question.model';
import { EssayQuestion } from '../../core/models/survey/essay-question.model';
import { SurveyService } from "../../core/services/survey.service";
import { UtilsService } from "../../core/services/utils.service";
import { Observable, Subscription } from 'rxjs';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators } from '@angular/forms';
import { map, tap, concatMap, concat, first, distinctUntilChanged, catchError } from 'rxjs/operators';
import { of, forkJoin } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastController } from '@ionic/angular';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';



@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.scss'],
})
export class SurveyComponent implements OnInit, OnDestroy {

  survey$: Observable<Survey>;
  survey: Survey;
  booking: Booking;
  real: Real;
  code: string;
  @Input() pricepilot: boolean;
  @Input() dm: boolean;
  @Input() dermacenter: boolean;

  surveyId: number = 4;
  doneQuestionId: string = '27';

  form: FormGroup;
  surveyAndBookingSubscription: Subscription;
  loading = false;
  tryToSubmit = false;

  constructor( private http: HttpClient, private surveyService: SurveyService, private formBuilder: FormBuilder, private route: ActivatedRoute, private router: Router, public toastController: ToastController, private utilsService: UtilsService ) { 
    //this.survey$ = this.surveyService.getSurveyBySurveyId(1);
  }

  ngOnDestroy() {
    this.surveyAndBookingSubscription.unsubscribe();
  }

  private getFormControlFromQuestion( question: Question & RatingQuestion & YesNoQuestion & EssayQuestion ) {

    let control: FormControl;

    let validators = [];

    if ( question.required ) {
      validators.push( Validators.required );
    }

    switch ( question.getClassName() ) {

      case 'YesNoQuestion':

        control = new FormControl( true, {
          updateOn: 'change',
          validators: validators,
        });

        break;

      case 'EssayQuestion':

        validators.push( Validators.maxLength( question.maxLength ) );

        control = new FormControl( null, {
          updateOn: 'change',
          validators: validators,
        });

        break;

      case 'SelectQuestion':

        validators.push( Validators.min( 1 ) );
        validators.push( Validators.pattern( '[0-9]+' ) );

        control = new FormControl( null, {
          updateOn: 'change',
          validators: validators,
        });

        break;

      case 'RatingQuestion':

        validators.push( Validators.min( question.minValue ) );
        validators.push( Validators.max( question.maxValue ) );

        control = new FormControl( null, {
          updateOn: 'change',
          validators: [ Validators.required ] ,
        });

        break;

    }


    if (!control) {
      return;
    }

    return control;

    //this.form.addControl(question.id, control);

  }

  private generateFormGroup( survey ) {

    if ( !survey.questions ) {
      return false;
    }


    let fgObj = {};

    survey.questions.map( question => {


      let gfq = this.getFormControlFromQuestion( question );

      if ( gfq ) {
        fgObj[ question.id ] = gfq;
      }

    })

    this.form = new FormGroup( fgObj )


  }

  ngOnInit() {


    /*if ( this.dm ) {
      this.surveyId = 2;
      this.doneQuestionId = '10';
    } else if ( this.dermacenter ) {
      this.surveyId = 3;
      this.doneQuestionId = '18';
    }*/

    this.survey$ = this.surveyService.getSurveyBySurveyId( this.surveyId );

    this.loading = true;

    function isNumeric( value ) {
      return /^\d+$/.test(value);
    }

    this.code = this.route.snapshot.queryParams.code; 
    
   

    let bookingId = this.route.snapshot.queryParams.booking; 


    if ( !this.code || !bookingId || !isNumeric( bookingId ) ) {
      
      this.presentToast( 'Napačna povezava!', 'danger' );

      this.router.navigate( [ 
        '/'
      ]);

      return false;
    }

    const reqHeader = new HttpHeaders({ 'Content-Type': 'application/json', 'No-Auth': 'True' });

    this.surveyAndBookingSubscription = forkJoin(
      {
        survey: this.survey$,
        booking: this.http.get( environment.apiUrl + '/surveys/' + this.surveyId +'/bookings/' + bookingId + '?expand=provider,bookingselectionitems&code=' + this.code, { headers: reqHeader })
          .pipe( 
            map( bookingJsonHal => new Booking( bookingJsonHal ) )
          ),
      }
    ).subscribe( result => {
      this.loading = false;
      this.generateFormGroup( result.survey );
      this.survey = result.survey;
      this.booking = result.booking;
      this.real = this.booking.getRootReal();

    }, error => {
      this.loading = false;
      this.presentToast( 'Neveljavna povezava!', 'danger');
      this.router.navigate( [ 
        '/'
      ]);

    });
     

  }

  async presentToast( text, color = 'tertiary', duration = 10000 ) {
    const toast = await this.toastController.create({
      message: text,
      duration: duration,
      color: color
    });
    toast.present();
  }



  onRatingChange(event) {
  }

  onFormSubmit() {

    this.tryToSubmit = true;

    if ( !this.form.valid && ( ( ( !this.dermacenter && !this.dm )  && ( true === this.form.get('1').value  || !this.form.get('2').value ) ) 
        || ( this.dermacenter && ( 'true' === this.form.get('18').value  || !this.form.get('19').value ) )
        || ( this.dm && ( true === this.form.get('10').value  || !this.form.get('11').value ) ) )

      ) {
      this.presentToast( 'Prosimo, da odgovorite na vsa vprašanja!', 'secondary', 5000)
      return false;
    }


   this.loading = true;

    this.surveyService.saveSurvey$( this.survey, this.form.value, this.code, this.booking ).subscribe( (response: HttpResponse<any>) => {

      this.loading = false;

      if ( true ) {
        this.router.navigate( [ 
          'oceni', 'hvala'
        ]);

      } else {

        this.presentToast( 'Hvala za vaše mnenje. Skupaj bomo lahko storitve še izboljšali.');

        this.router.navigate( [ 
          '/'
        ]);

      }

    }, error => {
      this.loading = false;
      this.presentToast( 'Joj. Prišlo je do napake pri shranjevanju. Poskusite ponovno ali kontaktirajte administratorja.', 'danger');
      //this.router.navigate( ['/restavracija', this.activatedRoute.snapshot.params.providerId, this.activatedRoute.snapshot.params.shopSlug, 'rezervacija', 'izberi-termin'] );
    }); 

  }


  /*book( user ) {

    this.loading = true;

    this.http.post(
      'https://api.pricepilot.io/users/' + this.authService.me.id + '/bookings', 
      this.pick.bookingPostObject, { observe: 'response' }
    )

    .subscribe( (response: HttpResponse<any>) => {
      console.log('booking saved');
      const loc = response.headers.get('location');
      const bookingId = loc.substr( loc.lastIndexOf('/') + 1 );
      this.cart.reset();

      this.loading = false;

      this.router.navigate( [ 
        '/restavracija', 
        this.activatedRoute.snapshot.params.providerId, 
        this.activatedRoute.snapshot.params.shopSlug,
        'rezervacija',
        'narejena',
        bookingId
      ]);

      console.log('navigacija opravljena');
      
    }, error => {
      console.log(error);
      this.presentToast( 'Joj. Nekdo vas je ravnokar prehitel. Prosimo izberite drug termin.');
      this.router.navigate( ['/restavracija', this.activatedRoute.snapshot.params.providerId, this.activatedRoute.snapshot.params.shopSlug, 'rezervacija', 'izberi-termin'] );
    }); 

  }*/



}
  